module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "prologue"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-transform": "uppercase",
      "font-weight": "740"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The New Year celebrations began with music, cheering and embracing, with salvos of large Chinese rockets releasing their thunderous booms and uniform radiance high in the evening sky above the town.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The noises from the celebrations were loud and slightly more than irritating for some. This would soon settle down to leave a healthy shared ambience through this warm and humid evening. The three Farang, two men and a woman, were seated at a well-presented table at one of the floating restaurants in Pattaya.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("They took a break from their drinks and colourful Thai cuisine to text their New Year greetings to friends and relatives. This was going to be a very happy year for them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0